import axios from '@/libs/api.request'

/**
 * 获取列表
 * @returns {wx.RequestTask | never}
 */
export const getList = (params) => {
  return axios.request({
    url: 'userManage/UserRechargeAddress/index',
    method: 'get',
    params: params
  })
}



export const refresh = (user_id,is_trc) => {
  return axios.request({
    url: 'userManage/UserRechargeAddress/refresh',
    method: 'get',
    params: {
      user_id: user_id,
      is_trc:is_trc
    }
  })
}


/**
 * 删除数据
 */
export const del = (id) => {
  return axios.request({
    url: 'userManage/UserRechargeAddress/del',
    method: 'get',
    params: {
      id: id
    }
  })
}


/**
* 锁定/解锁
*/
export const lock = (id) => {
return axios.request({
url: 'userManage/UserRechargeAddress/lock',
method: 'get',
params: {
id: id
}
})
}

/**
* 获取列表
* @returns {wx.RequestTask | never}
*/
export const getParams = () => {
return axios.request({
url: 'userManage/UserRechargeAddress/getParams',
method: 'get'
})
}


/**
 * 改变状态按钮
 * @param status
 * @param id
 * @returns {wx.RequestTask | never}
 */
export const changeStatus = (status, id) => {
  return axios.request({
    url: 'userManage/UserRechargeAddress/changeStatus',
    method: 'get',
    params: {
      status: status,
      id: id
    }
  })
}

/**
 * 新增
 * @param data
 * @returns {wx.RequestTask | never}
 */
export const add = (data) => {
  return axios.request({
    url: 'userManage/UserRechargeAddress/add',
    method: 'post',
    data
  })
}

/**
 * 编辑
 * @param data
 * @returns {wx.RequestTask | never}
 */
export const edit = (data) => {
  return axios.request({
    url: 'userManage/UserRechargeAddress/edit',
    method: 'post',
    data
  })
}
